import { DetailBtnConfig, DetailButtonSize, DetailButtonType } from '@tencent/wphk-act-base-components';
import { i18n } from '../i18n';
import { C2CDialogCouponState, TipsDialogLogo } from '../types';

/** 弹窗 logo */
export const TIPS_DIALOG_LOGO = {
  [TipsDialogLogo.Phone]:
    'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20240828173246/dialog_top_1.png',
  [TipsDialogLogo.Hand]:
    'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20240828173246/dialog_top_2.png',
};

// 中转页链接
export const REDIRECT_URL = 'https://prom.wechatpay.com.hk/discount-code-thirdapp/index.shtml';

// 页面链接
export const PAGE_URL = 'https://prom.wechatpay.com.hk/merchant-channel/index.shtml';

/** 微信分享adtag */
export enum ShareAdtag {
  'wx' = 'from_wx',
  'copy' = 'from_copy',
}

/** 券详情弹窗按钮配置 */
export const COUPON_DIALOG_BTN_CONF: { [key in C2CDialogCouponState]: DetailBtnConfig } = {
  [C2CDialogCouponState.used]: {
    isShowBtn: false,
  },
  [C2CDialogCouponState.expired]: {
    isShowBtn: false,
  },
  [C2CDialogCouponState.received]: {
    isShowBtn: true,
    btnText: i18n('去使用'),
    size: DetailButtonSize.normal,
    type: DetailButtonType.ghost,
  },
  [C2CDialogCouponState.limit]: {
    isDisabled: true,
    isShowBtn: true,
    btnText: i18n('今日已領完'),
    size: DetailButtonSize.normal,
    type: DetailButtonType.outofperiod,
  },
  [C2CDialogCouponState.locked]: {
    isDisabled: true,
    isShowBtn: true,
    btnText: i18n('待解鎖'),
    size: DetailButtonSize.normal,
    type: DetailButtonType.outofperiod,
  },
  [C2CDialogCouponState.notReceived]: {
    isShowBtn: true,
    btnText: i18n('立即領取'),
    size: DetailButtonSize.normal,
    type: DetailButtonType.primary,
  },
  [C2CDialogCouponState.unknown]: {
    isShowBtn: false,
  },
};
